import { render, staticRenderFns } from "./StepRezeptService.vue?vue&type=template&id=2442e94a"
import script from "./StepRezeptService.vue?vue&type=script&lang=js"
export * from "./StepRezeptService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports